import * as React from "react"

function InstagramSvg(props) {
    return (
        <svg width={26} height={26} viewBox="0 0 26 26" {...props}>
            <path
                d="M17.333 13A4.333 4.333 0 1113 8.667 4.341 4.341 0 0117.333 13zm2.336 0A6.669 6.669 0 1013 19.669 6.66 6.66 0 0019.669 13zm1.828-6.94a1.557 1.557 0 10-1.557 1.557A1.553 1.553 0 0021.5 6.06zM13 2.337c1.9 0 5.958-.152 7.667.525a4.432 4.432 0 012.471 2.471c.677 1.71.525 5.772.525 7.667s.152 5.958-.525 7.667a4.432 4.432 0 01-2.471 2.471c-1.71.677-5.772.525-7.667.525s-5.958.152-7.667-.525a4.432 4.432 0 01-2.471-2.471c-.677-1.71-.525-5.772-.525-7.667s-.152-5.958.525-7.667a4.432 4.432 0 012.471-2.471C7.042 2.184 11.1 2.337 13 2.337zM26 13c0-1.794.017-3.571-.085-5.365A7.2 7.2 0 0018.366.086c-1.794-.1-3.571-.085-5.365-.085S9.43-.016 7.636.086A7.2 7.2 0 00.087 7.635C-.013 9.429.002 11.206.002 13s-.017 3.571.085 5.365a7.2 7.2 0 007.549 7.549c1.794.1 3.571.085 5.365.085s3.571.017 5.365-.085a7.2 7.2 0 007.549-7.549C26.016 16.571 26 14.794 26 13z"
                fill="#fff"
                fillRule="evenodd"
            />
        </svg>
    )
}

export default InstagramSvg
